import {
  FETCH_ANEES_VOUCHERS_DATA,
  FETCH_ANEES_VOUCHERS_SUCCESS,
  FETCH_ANEES_VOUCHERS_FAILURE,
} from "./actionTypes";

export const fetchAneesVouchersData = () => ({
  type: FETCH_ANEES_VOUCHERS_DATA,
});

export const fetchAneesVouchersSuccess = (data) => ({
  type: FETCH_ANEES_VOUCHERS_SUCCESS,
  payload: data,
});

export const fetchAneesVouchersFailure = (error) => ({
  type: FETCH_ANEES_VOUCHERS_FAILURE,
  payload: error,
});
